/* ============================================================
   KS HEADER HEIGHT TRACKER
   ------------------------------------------------------------
   Misst die tatsächliche Höhe des fixed Headers (.uh-wrap) und
   schreibt sie als CSS-Variable --ks-header-height-mobile auf
   das :root-Element. Damit weiß das Sticky-Burger-Menü exakt,
   wo es kleben soll - egal ob die Promotion-Bar an oder aus ist,
   ob das Logo wechselt oder ob ein Event-Banner reinkommt.

   EINBINDUNG: In layout/theme.liquid VOR </body>:
     <script src="{{ 'ks-header-height.js' | asset_url }}" defer></script>

   Stand: 21.05.2026 - Phase 2 Hotfix
   ============================================================ */

(function () {
  'use strict';

  function updateHeaderHeight() {
    var header = document.querySelector('.uh-wrap');
    if (!header) return;

    var height = Math.ceil(header.getBoundingClientRect().height);

    // Auf Root als CSS-Variable schreiben
    document.documentElement.style.setProperty(
      '--ks-header-height-mobile',
      height + 'px'
    );

    // Auch generisch (für Desktop-Verwendung später)
    document.documentElement.style.setProperty(
      '--ks-header-height',
      height + 'px'
    );
  }

  // Initial messen (DOM ready)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderHeight);
  } else {
    updateHeaderHeight();
  }

  // Nach komplettem Laden nochmal (Logos, Fonts, etc.)
  window.addEventListener('load', updateHeaderHeight);

  // Bei Resize / Orientation-Wechsel
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateHeaderHeight, 150);
  });

  // Wenn Promotion-Bar / Event-Bar dynamisch ein-/ausgeblendet wird
  // ResizeObserver fängt das automatisch ab
  if (typeof ResizeObserver !== 'undefined') {
    var header = document.querySelector('.uh-wrap');
    if (header) {
      var observer = new ResizeObserver(updateHeaderHeight);
      observer.observe(header);
    }
  }
})();
